import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./login/login.module').then(x => x.LoginModule) },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(x => x.DashboardModule), canActivate: [AuthGuard] },
  { path: 'insurance-lookup', loadChildren: () => import('./insurance-lookup/insurance-lookup.module').then(x => x.InsuranceLookupModule), canActivate: [AuthGuard] },
  { path: 'claim-tracker', loadChildren: () => import('./claim-tracker/claim-tracker.module').then(m => m.ClaimTrackerModule), canActivate: [AuthGuard] },
  { path: 'patient', loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule), canActivate: [AuthGuard] },
  { path: 'submit-preAuth/:id', loadChildren: () => import('./submit-pre-auth/submit-pre-auth.module').then(m => m.SubmitPreAuthModule), canActivate: [AuthGuard] },
  { path: 'setup-doctors', loadChildren: () => import('./setup-doctors/setup-doctors.module').then(m => m.SetupDoctorsModule), canActivate: [AuthGuard] },
  { path: 'payer-details', loadChildren: () => import('./payer-details/payer-details.module').then(m => m.PayerDetailsModule), canActivate: [AuthGuard] },
  { path: 'hospitals', loadChildren: () => import('./hospitals/hospitals.module').then(m => m.HospitalsModule), canActivate: [AuthGuard] },
  { path: 'check-eligibility', loadChildren: () => import('./check-eligibility/check-eligibility.module').then(m => m.CheckEligibilityModule), canActivate: [AuthGuard] },
  { path: 'submit-discharge-preAuth/:id', loadChildren: () => import('./pre-auth-discharge/pre-auth-discharge.module').then(m => m.PreAuthDischargeModule), canActivate: [AuthGuard] },
  { path: 'submit-claim/:id', loadChildren: () => import('./claim-submit/claim-submit.module').then(m => m.ClaimSubmitModule), canActivate: [AuthGuard] },
  { path: 'new-admission', loadChildren: () => import('./new-admission/new-admission.module').then((x) => x.NewAdmissionModule), canActivate: [AuthGuard] },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
